export class SupplierResource {
    public supplierResourceID: string;
    public supplierRegionID: string;
    public slotStart: Date;
    public slotEnd: Date;
    public availableSlot: number;
    public reservedSlot: number;
}
